export default "__VITE_ASSET__CcoZGc2L__"